import { render, staticRenderFns } from "./DuplicateSearch.vue?vue&type=template&id=c592cc88&scoped=true&"
import script from "./DuplicateSearch.vue?vue&type=script&lang=js&"
export * from "./DuplicateSearch.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateSearch.vue?vue&type=style&index=0&id=c592cc88&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c592cc88",
  null
  
)

export default component.exports